// import { useState, useEffect } from 'react';
// // import axios from 'axios';
// import { POST_DMT_INSTANT_PAY_CUSTOMER_INFO, POST_DMT_INSTANT_PAY_OTP_VERIFICATION } from './../../Utils/appConstants';
// import { isNumber } from '../../Utils/Common';
// import { useHistory } from "react-router-dom";
// import PropagateLoader from "react-spinners/PropagateLoader";
// // import { ToastContainer } from 'react-toastify';
// import AddCustomer from './addCustomer';
// import ViewCustomer from './viewCustomer';
// // import RefundHistory from './refund';
// import { postRequest } from '../../Utils/AppApi';
// import { toast } from 'react-toastify';
// import { Modal } from 'antd';

// const MyComponent = (props) => {
//     const history = useHistory();
//     // const tabPosition = 'left';
//     const [isLoading, setLoading] = useState(false);
//     const [searchText, setSearchText] = useState(null);
//     const [timer, setTimer] = useState(null);
//     const [isCustomerInfo, setCustomerInfo] = useState(null);
//     const [isCustomerNotExist, setCustomerNotExist] = useState(false);
//     // const [searchButton, setSearchButton] = useState(true);
//     const [isOtpModal, setOtpModal] = useState(false);
//     const [otpCode, setOtpCode] = useState(null)
//     const [referenceKey, setReferenceKey] = useState(null);

//     useEffect(() => {
//         if(props.mobile) {
//         setSearchText(props.mobile)
//     }
//     }, [props.mobile]) // eslint-disable-line react-hooks/exhaustive-deps

//     useEffect(() => {
//         if (searchText) {
//             if (timer) {
//                 clearTimeout(timer)
//                 setTimer(null)
//             }
//             setTimer(
//                 setTimeout(() => {
//                     if (searchText.length === 10) {
//                         // setSearchButton(false)
//                         getCustomerInfo()
//                     } else {
//                         setCustomerNotExist(false);
//                         // toast.error("Please enter a valid Mobile Number.")
//                     }
//                 }, 1000)
//             )
//         }
//     }, [searchText]) // eslint-disable-line react-hooks/exhaustive-deps

//     // const handleSearch = (e) => {
//     //     // console.log("searchText----",e.target.value)
//     //     if (e.target.value.length === 10) {
//     //         setSearchButton(false)
//     //     } else {
//     //         setCustomerInfo(null)
//     //         setSearchButton(true)
//     //     }
//     //     setSearchText(e.target.value);
//     // }

//     // const findCustomerInfo = (mobile) => {
//     //     setSearchText(null)
//     //     setSearchText(mobile)
//     // }
//     // const getBankListData = async () => {
//     // await getRequest(GET_AEPS_BANK_LIST, history).then((response) => {
//     //     if (response.success === true) {
//     //         setBankList(response.data.map(item => {
//     //             return { "value": item.iin, "label": item.name };
//     //         }));
//     //     } else {
//     //         toast.error(response.message);
//     //     }
//     // }).catch(function (error) {
//     //     console.log(error)
//     //     // setLoading(false);
//     // })
//     // }

//     const getCustomerInfo = async () => {
//         setLoading(true)
//         if (!searchText) {
//             toast.error("Please enter a Customer Number");
//             setLoading(false)
//             return false;
//         } else if (searchText.length !== 10) {
//             toast.error("Please enter a valid Mobile Number");
//             setLoading(false)
//             return false;
//         }
//         let payload = { "customerMobile": searchText }
//         await postRequest(POST_DMT_INSTANT_PAY_CUSTOMER_INFO, payload, history).then((response) => {
//             if (response.success === true) {
//                 if (response.isotp === true) {
//                     setOtpModal(true);
//                 } else {
//                     setCustomerInfo(response.data);
//                     setCustomerNotExist(false)
//                 }
//                 setReferenceKey(response.data.referenceKey);
//                 // console.log("----------------", response.data);
//             } else {
                
//                   if (response?.data && response?.data?.referenceKey) {

//                     setCustomerNotExist(true);
//                     setReferenceKey(response.data.referenceKey);

//                 } else {
//                     alert(response?.message || "Something went wrong. Please try again.");
//                 }

//                 // setCustomerNotExist(true);
//                 // setReferenceKey(response.data.referenceKey);
//                 // console.log("----------------", response.success);
//             }
//             setLoading(false)
//         }).catch(function (error) {
//             console.log(error)
//             setLoading(false);
//         })
//     }

//     const handleCustomerVerify = () => {
//         // console.log("verify ========== ")
//         if (otpCode) {
//             setLoading(true)
//             // console.log("otpCode ===================== ", otpCode)
//             const payload = {
//                 referenceKey: referenceKey,
//                 otp: otpCode,
//                 customerMobile: searchText,
//             };

//             postRequest(`${POST_DMT_INSTANT_PAY_OTP_VERIFICATION}`, payload, history).then((response) => {
//                 if (response.success === true) {
//                     setOtpModal(false);
//                     getCustomerInfo();
//                     toast.success(response.message);
//                 } else {
//                     toast.error(response.message);
//                 }
//                 setLoading(false)
//             }).catch(function (error) {
//                 // console.log(error)
//                 setLoading(false)
//             })
//         } else {
//             toast.error("OTP code is required");
//         }
//     }

//     const onChangeOtpValue = (value) => {
//         setOtpCode(value);
//     }

//     if (isLoading) {
//         return <div className="content text-center" style={{ margin: "250px 0" }}>
//             <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
//         </div>
//     }
//     return (
//         <div>
//             <div className="">
//                 <div className="">
//                     {/* <div className='row mb-3'>
//                         <div className="input-group">
//                             <div className="col-md-2"></div>
//                             <div className="col-md-4">
//                                 <input className="form-control py-2 border" type="search" defaultValue={searchText} value={searchText} onKeyDown={isNumber} placeholder='Search ...' maxLength={10} onChange={(e) => handleSearch(e)} />
//                             </div>
//                             <button onClick={() => getCustomerInfo()} className="btn btn-primary ml-3 border-left-0 border" disabled={searchButton} type="button">
//                                 <i className="fa fa-search" /> Search
//                             </button>
//                         </div>
//                     </div> */}
//                     {(isCustomerNotExist) && <AddCustomer mobile={searchText} findCustomerInfo={getCustomerInfo} referenceKey={referenceKey} />}
//                     {(isCustomerInfo && !isCustomerNotExist) && <ViewCustomer isCustomerInfo={isCustomerInfo} findCustomerInfo={getCustomerInfo} />}
//                 </div>
//                 {isOtpModal && <Modal title={"Customer Verification OTP"} width={600} open={isOtpModal} onOk={() => handleCustomerVerify()} onCancel={() => setOtpModal(false)} okText={"Submit"} >
//                     <div className="form-group">
//                         <label>OTP Code</label>
//                         <div className="input-group">
//                             <div className="custom-file">
//                                 <input type="text" className="form-control" name="otpCode" placeholder="OTP Code" onChange={(e) => onChangeOtpValue(e.target.value)} autoComplete="off" value={otpCode} maxLength={6} onKeyDown={isNumber} />
//                             </div>
//                         </div>
//                     </div>
//                 </Modal>}
//             </div>
//         </div>
//     )
// }

// export default MyComponent;

import { useState, useEffect } from 'react';
import { POST_DMT_INSTANT_PAY_CUSTOMER_INFO, POST_DMT_INSTANT_PAY_OTP_VERIFICATION } from './../../Utils/appConstants';
import { isNumber } from '../../Utils/Common';
import { useHistory } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import AddCustomer from './addCustomer';
import ViewCustomer from './viewCustomer';
import { postRequest } from '../../Utils/AppApi';
import { toast } from 'react-toastify';
import { Modal } from 'antd';

const MyComponent = (props) => {
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState(null);
    const [timer, setTimer] = useState(null);
    const [isCustomerInfo, setCustomerInfo] = useState(null);
    const [isCustomerNotExist, setCustomerNotExist] = useState(false);
    const [isOtpModal, setOtpModal] = useState(false);
    const [otpCode, setOtpCode] = useState(null);
    const [referenceKey, setReferenceKey] = useState(null);

    // ---- Parent-passed referenceKey / validity (from POST_DMT_REFRESH_SERVICE) ----
    const parentReferenceKey = props?.referenceKey || '';
    const parentValidity = props?.validity || '';

    useEffect(() => {
        if (props.mobile) {
            setSearchText(props.mobile);
        }
    }, [props.mobile]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (searchText) {
            if (timer) {
                clearTimeout(timer);
                setTimer(null);
            }
            setTimer(
                setTimeout(() => {
                    if (searchText.length === 10) {
                        getCustomerInfo();
                    } else {
                        setCustomerNotExist(false);
                    }
                }, 1000)
            );
        }
    }, [searchText]); // eslint-disable-line react-hooks/exhaustive-deps

    const getCustomerInfo = async () => {
        setLoading(true);
        if (!searchText) {
            toast.error("Please enter a Customer Number");
            setLoading(false);
            return false;
        } else if (searchText.length !== 10) {
            toast.error("Please enter a valid Mobile Number");
            setLoading(false);
            return false;
        }
        let payload = { "customerMobile": searchText };
        await postRequest(POST_DMT_INSTANT_PAY_CUSTOMER_INFO, payload, history).then((response) => {
            if (response.success === true) {
                if (response.isotp === true) {
                    setOtpModal(true);
                } else {
                    // ---- Merge parent referenceKey / validity into customer data ----
                    const merged = mergeReferenceKey(response.data);
                    setCustomerInfo(merged);
                    setCustomerNotExist(false);
                }
                // Track the API's own referenceKey for the OTP step
                setReferenceKey(response.data?.referenceKey || parentReferenceKey || null);
            } else {
                if (response?.data && response?.data?.referenceKey) {
                    setCustomerNotExist(true);
                    setReferenceKey(response.data.referenceKey);
                } else {
                    alert(response?.message || "Something went wrong. Please try again.");
                }
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });
    };

    // ---- Merge helper: parent values win if API doesn't provide them ----
    const mergeReferenceKey = (data) => {
        if (!data) return data;
        const merged = { ...data };

        // Customer-level referenceKey
        if (!merged.referenceKey && parentReferenceKey) {
            merged.referenceKey = parentReferenceKey;
        }
        // Customer-level validity
        if (!merged.validity && parentValidity) {
            merged.validity = parentValidity;
        }

        // Some backends nest them under customerData
        if (merged.customerData) {
            if (!merged.customerData.referenceKey && parentReferenceKey) {
                merged.customerData = {
                    ...merged.customerData,
                    referenceKey: parentReferenceKey,
                };
            }
            if (!merged.customerData.validity && parentValidity) {
                merged.customerData = {
                    ...merged.customerData,
                    validity: parentValidity,
                };
            }
        }

        console.log('[InstantPay] merged customerData =', merged);
        return merged;
    };

    const handleCustomerVerify = () => {
        if (otpCode) {
            setLoading(true);
            const payload = {
                referenceKey: referenceKey,
                otp: otpCode,
                customerMobile: searchText,
            };

            postRequest(`${POST_DMT_INSTANT_PAY_OTP_VERIFICATION}`, payload, history).then((response) => {
                if (response.success === true) {
                    setOtpModal(false);
                    getCustomerInfo();
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
            });
        } else {
            toast.error("OTP code is required");
        }
    };

    const onChangeOtpValue = (value) => {
        setOtpCode(value);
    };

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>;
    }

    return (
        <div>
            <div className="">
                <div className="">
                    {(isCustomerNotExist) &&
                        <AddCustomer
                            mobile={searchText}
                            findCustomerInfo={getCustomerInfo}
                            referenceKey={referenceKey}
                        />
                    }
                    {(isCustomerInfo && !isCustomerNotExist) &&
                        <ViewCustomer
                            isCustomerInfo={isCustomerInfo}
                            findCustomerInfo={getCustomerInfo}
                        />
                    }
                </div>
                {isOtpModal && <Modal
                    title={"Customer Verification OTP"}
                    width={600}
                    open={isOtpModal}
                    onOk={() => handleCustomerVerify()}
                    onCancel={() => setOtpModal(false)}
                    okText={"Submit"}
                    maskClosable={false}
                    keyboard={false}
                >
                    <div className="form-group">
                        <label>OTP Code</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="otpCode"
                                    placeholder="OTP Code"
                                    onChange={(e) => onChangeOtpValue(e.target.value)}
                                    autoComplete="off"
                                    value={otpCode}
                                    maxLength={6}
                                    onKeyDown={isNumber}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>}
            </div>
        </div>
    );
};

export default MyComponent;